import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as CheckMark } from '../../../../assets/icons/check-mark.svg';
import "./index.scss";
import { currencyFormatter } from '../../../../utils/currency';
import { RootState } from '../../../../store';
import { Page } from '../../../../enums/page';
import React, { useEffect, useMemo } from 'react';
import i18n from '../../../../utils/translations/i18n';
import { calculateThresholdStatus } from '../../../../utils/cart';

const GlobalDiscountSummary = ({ cart, globalDiscountData }: any) => {
    const {
        applicationState: { currentPage, globalDiscounDescription }
    } = useSelector((state: RootState) => state);

    const dispatch = useDispatch();
    const { t } = i18n;


    const discountDescription = globalDiscountData?.description || globalDiscounDescription || '';


    const { threshold, cartSubTotal, isThresholdMet,remainingAmountCent, percentage } = useMemo(() => {
        if (!globalDiscountData || currentPage !== Page.SHOPPINGBAG || cart.appliedGlobalDiscountId) return {};

        const { threshold, cartSubTotal, isThresholdMet,remainingAmountCent, percentage } = calculateThresholdStatus(cart, globalDiscountData?.cartSubTotal);

        return {
            threshold,
            cartSubTotal,
            isThresholdMet,
            remainingAmountCent,
            percentage,
        };
    }, [globalDiscountData, cart]);


    if (discountDescription && (currentPage !== Page.SHOPPINGBAG || !globalDiscountData)) {
        return (
            <div className="global-discount-summary order-summary-global-discount" data-testid="global-discount-summary">
                <div className="discount-desc">
                    <span className="discount-desc-text">{discountDescription}</span>
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            {discountDescription &&<div className="global-discount-summary" data-testid="global-discount-summary">
                <div className="discount-desc">
                    <span className="discount-desc-text">{discountDescription}</span>
                </div>
                {!cart.appliedGlobalDiscountId && !globalDiscountData?.matchesCart ? (
                    <div className="no-items-eligible">
                        <span className="no-items-text">
                        {t('shopping_cart_details.no_items_elligible')}
                        </span>
                    </div>
                ) : !cart.appliedGlobalDiscountId && (threshold && !isThresholdMet) ? (
                    <div className="threshold">
                        <div className="more-needed">
                            <span className="more-needed-text">
                            {t('shopping_cart_details.add_amount').replace('[X]',currencyFormatter(remainingAmountCent, cart?.fractionDigits))}
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className="discount-applied">
                        <CheckMark className="checkmark" />
                        <span className="discount-applied-text">{t('shopping_cart_details.offer_applied')}</span>
                    </div>
                )}
            </div>}
            {discountDescription && threshold && !isThresholdMet && globalDiscountData?.matchesCart && !cart.appliedGlobalDiscountId && (
                <div className="progress-container">
                    <div className="progress-bar" style={{ width: `${percentage}%` }}></div>
                </div>
            )}
        </React.Fragment>
    );
};

export default GlobalDiscountSummary;
